export function publicProfileToDisplayName({ displayName = '', username }){
  return `${displayName || username}`.trim()
}

export function publicProfileToPathname({ username, asMemberOf }){
  if (username) return asMemberOf
    ? `/${asMemberOf}/members/@${username}`
    : `/@${username}`
}
